import { render, staticRenderFns } from "./OnboardingCandidates.vue?vue&type=template&id=64b39816&scoped=true&"
import script from "./OnboardingCandidates.vue?vue&type=script&lang=js&"
export * from "./OnboardingCandidates.vue?vue&type=script&lang=js&"
import style0 from "./OnboardingCandidates.vue?vue&type=style&index=0&lang=css&"
import style1 from "./OnboardingCandidates.vue?vue&type=style&index=1&id=64b39816&scoped=true&lang=css&"
import style2 from "./OnboardingCandidates.vue?vue&type=style&index=2&id=64b39816&scoped=true&lang=css&"
import style3 from "./OnboardingCandidates.vue?vue&type=style&index=3&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64b39816",
  null
  
)

export default component.exports